export function getTokenScheme(tokenParts: string[]): string | undefined {
    if (tokenParts?.length > 0) {
        const scheme = tokenParts[0]?.toLowerCase();
        return tokenParts[1]?.length > 0 ? scheme : undefined;
    }

    return undefined;
}
